import React, { useContext, useState } from 'react';
import {
    Box,
    Button,
    MenuItem,
    TextField,
    Grid,
    Autocomplete,
    Checkbox,
    ListItemText,
    Chip,
    Tooltip,
} from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { CommonContext, MerchantWarehouseContext } from '../../context';
import { status as statusOptions } from '../../utils/config';
import CommonDateRangePicker from '../common/CommonDateRangePicker';

export default function FilterBar() {
    const { merchant, user } = useContext(CommonContext);
    const { filters, setFilters, initialFilters, onLoadApi } = useContext(MerchantWarehouseContext);
    const [showAllMerchants, setShowAllMerchants] = useState(false);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters(prev => ({
            ...prev,
            dateRange: { startDate, endDate }
        }));
    };

    const handleSubmit = () => {
        onLoadApi();
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
        setShowAllMerchants(false);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                {user?.user_type !== 'Merchant' && (
                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Autocomplete
                            multiple
                            options={merchant || []}
                            getOptionLabel={(option) => option.company_name}
                            value={(merchant || []).filter(item => (filters.merchant_id || []).includes(item.id))}
                            onChange={(e, newValue) => {
                                const selectedIds = newValue.map(item => item.id);
                                handleChange('merchant_id', selectedIds);
                            }}
                            disableCloseOnSelect
                            limitTags={1}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Tooltip key={option.id} title={option.company_name}>
                                        <Chip
                                            label={option.company_name}
                                            {...getTagProps({ index })}
                                            size="small"
                                            sx={{ maxWidth: 100 }}
                                            onClick={() => setShowAllMerchants(true)}
                                        />
                                    </Tooltip>
                                ))
                            }
                            renderOption={(props, option, { selected }) => (
                                <li {...props} key={option.id}>
                                    <Checkbox checked={selected} />
                                    <ListItemText primary={option.company_name} />
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Merchants"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                            onClick={() => setShowAllMerchants(true)}
                            sx={{
                                width: '100%',
                                '& .MuiInputBase-root': {
                                    height: showAllMerchants ? 'auto !important' : '30px',
                                    overflow: 'hidden',
                                    alignItems: 'flex-start',
                                    whiteSpace: 'normal',
                                },
                                '& .MuiChip-root': {
                                    maxWidth: '100px',
                                },
                            }}
                        />
                    </Grid>
                )}

                <Grid item size={{ xs: 12, md: 3 }}>
                    <TextField
                        select
                        label="Status"
                        name="status"
                        value={filters.status}
                        onChange={(e) => handleChange('status', e.target.value)}
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="">Status</MenuItem>
                        {Object.entries(statusOptions).map(([key, value]) => (
                            <MenuItem value={key} key={key}>
                                {value}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <Box className="date-picker-wrapper">
                        <CommonDateRangePicker
                            startDate={filters?.dateRange?.startDate}
                            endDate={filters?.dateRange?.endDate}
                            onChange={handleDateRangeChange}
                        />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 2 }}>
                    <Box className="filter-actions" sx={{ justifyContent: 'flex-start', mt: 0.5 }}>
                        <Button className="search-btn" variant="contained" size="medium" onClick={handleSubmit}>
                            Search
                        </Button>

                        <Button className="reset-btn ml-2" variant="outlined" size="medium" onClick={handleReset}>
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
